import {LocalStorageKeys} from './keys';


export function isCart(potentialCart) {
  return (
    potentialCart != null &&
    potentialCart.id != null &&
    potentialCart.checkoutUrl != null &&
    potentialCart.lines != null &&
    Array.isArray(potentialCart.lines) &&
    typeof potentialCart.totalQuantity === 'number'
  );
}

function set(key, value) {
  const isBrowser = typeof window !== 'undefined';
  if (isBrowser) {
    window.localStorage.setItem(key, value);
  }
}

function remove(key) {
  const isBrowser = typeof window !== 'undefined';
  if (isBrowser) {
    window.localStorage.removeItem(key);
  }
}

function get(key) {
  const isBrowser = typeof window !== 'undefined';
  if (!isBrowser) {
    return null;
  }

  try {
    const item = window.localStorage.getItem(key);
    return item;
  } catch {
    return null;
  }
}

function getInitialCart() {
  const existingCartString = get(LocalStorageKeys.CART);
  if (existingCartString == null) {
    return null;
  }

  try {
    const existingCart = JSON.parse(existingCartString);
    if (!isCart(existingCart)) {
      return null;
    }

    return existingCart;
  } catch {
    return null;
  }
}

export const LocalStorage = {
  get,
  set,
  remove,
  getInitialCart,
};